import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { LoginPage, VerifyOtpPage } from "../features/auth";
import { DashboardPage } from "../features/dashboard";
import { UserDetailPage, UsersPage } from "../features/users";
import { RevenuePage } from "../features/revenue";
import { SettingsPage } from "../features/settings";
import AppLayout from "../components/layout/AppLayout";
import DocumentTitle from "./documentTitle";
import { RedirectIfSignedIn, RequireAuth } from "./guards";
import { ROUTES } from "./paths";

/**
 * Route table for the panel. The two sign-in screens render standalone and are
 * closed to anyone already signed in; everything behind `RequireAuth` renders
 * inside `AppLayout`, which supplies the rail.
 *
 * Signing in ends on the dashboard and nowhere else — there is no onboarding,
 * no plan to pick, nothing between the code and the console.
 */
const AppRoutes: React.FC = () => (
  <>
    <DocumentTitle />
    <Routes>
      <Route path="/" element={<Navigate to={ROUTES.dashboard} replace />} />

      <Route element={<RedirectIfSignedIn />}>
        <Route path={ROUTES.login} element={<LoginPage />} />
        <Route path={ROUTES.verifyOtp} element={<VerifyOtpPage />} />
      </Route>

      <Route element={<RequireAuth />}>
        <Route element={<AppLayout />}>
          <Route path={ROUTES.dashboard} element={<DashboardPage />} />
          <Route path={ROUTES.users} element={<UsersPage />} />
          <Route path={ROUTES.userDetail} element={<UserDetailPage />} />
          <Route path={ROUTES.revenue} element={<RevenuePage />} />
          <Route path={ROUTES.settings} element={<SettingsPage />} />
        </Route>
      </Route>

      {/* Anything else is a typo or a link to a screen that no longer exists.
          The dashboard is the one destination that is always right — and the
          guard above turns it into the login card for anyone signed out. */}
      <Route path="*" element={<Navigate to={ROUTES.dashboard} replace />} />
    </Routes>
  </>
);

export default AppRoutes;
